import * as React from 'react';
import {Locator} from './Locator';
import {Overlayer} from './Overlayer';
import type {Box} from '@packages/utilities/box';
import {useSpringModalViewport} from './useSpringModalViewport';

type RendererProps = {
  viewport: Box;
  anchor?: Box;
  target?: Box;
  targetRef: React.RefObject<any>;
};
type Props = {
  open?: boolean | null | undefined;
  render: (arg1: RendererProps) => React.ReactElement;
  children: (arg1: React.RefObject<any>) => React.ReactNode;
};
export const Positioner: React.ComponentType<Props> = ({
  open,
  render,
  children,
}) => {
  const viewport = useSpringModalViewport();

  return (
    // SHSVS-8448: gate the anchor `Locator` on `open` so closed tooltips
    // don't attach idle ResizeObservers or call getBoundingClientRect on
    // every mount/update. This matches the perf optimization Nate added
    // to `DeprecatedPositioner` in PR #97682, which was never applied to
    // `Positioner`. Flagged by @flowN8 in #105399 review.
    <Locator active={Boolean(open)}>
      {(anchorRef, anchor) => (
        <Overlayer
          open={Boolean(open)}
          render={() => (
            <Locator>
              {(targetRef, target) =>
                render({
                  viewport,
                  anchor,
                  target,
                  targetRef,
                })
              }
            </Locator>
          )}
        >
          {children(anchorRef)}
        </Overlayer>
      )}
    </Locator>
  );
};

Positioner.displayName = 'Positioner';
